export enum DescriptionPage {
  Title = 'Helixbook',
  MetaDescription = 'Helixbook – более 2000 статей об анализах и различных заболеваниях: информация о причинах возникновения патологических состояний, методах их диагностики, подходах к лечению.',
  Description = `Мы собрали для вас более 2000 экспертных статей о заболеваниях 
  и показателях, которые применяются для их диагностики. 
  <br/>Здесь вы найдете подробную информацию об анализах, их назначении, методах исследования, интерпретации результатов и патологиях.`,
}
